export const DELETE_LABEL_MODAL_LABELS = {
	TITLE: 'Delete label?',
	BODY_PREFIX: "You're about to delete the custom label ",
	BODY_SUFFIX: '. You cannot undo this action.',
	CONFIRM: 'Delete Label',
	CANCEL: 'Cancel',
	DELETE_FAILED: 'Could not delete the label. Please try again.'
} as const;
